<template>
  <div id="solutions">
  	<div class="solution-wrapper">
  		<b-container fluid class="solution-header">
	  		<b-row v-if="enable_filters">
	  			<b-col lg="2">
	  				<div class="sol-filter">
	  					<b-form-select v-model="selected">
					      <option :value="selected">Tag Subject</option>
					      <option value="a">Option A</option>
					      <option value="b" disabled>Option B (disabled)</option>
					      <optgroup label="Grouped Options">
					        <option :value="{'C':'3PO'}">Option  object value</option>
					        <option :value="{'R':'2D2'}">Another option with object value</option>
					      </optgroup>
					    </b-form-select>
	  				</div>
	  			</b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-form-select v-model="selected">
					      <option :value="selected">Chapter</option>
					      <option value="a">A to Z</option>
					      <option value="a">Z to A</option>
					      <option value="a">Low Star</option>
					      <option value="a">High Star</option>
					    </b-form-select>
	  				</div>
	  			</b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-form-select v-model="selected">
					      <option :value="selected">Date</option>
					      <option value="a">Accending</option>
					      <option value="a">Decending</option>
					    </b-form-select>
	  				</div>
	  			</b-col>
	  			<b-col lg="2"></b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-form-input id="exampleInput1"
			                type="search"
			                v-model="search"
			                required
			                placeholder="Query Name">
			          </b-form-input>
	  				</div>
	  			</b-col>
	  			<b-col lg="2">
					<div class="sol-filter">
	  					<b-button type="submit" class="query-btn" variant="primary">Submit</b-button>
	  				</div>
	  			</b-col>
	  		</b-row>
  		</b-container>
      
      <b-container fluid>
        <b-row>
          <b-col lg=4 style="text-align:center">
            <h4 style="text-align:center">Total Credit</h4>
            <h4>{{user.credits.credit}}</h4>
          </b-col>
          <b-col lg=4 style="text-align:center">
            <h4 style="text-align:center">Total Debit</h4>
            <h4>{{user.credits.debit}}</h4>
          </b-col>
          <b-col lg=4 style="text-align:center">
            <h4 >Balance</h4>
            <h4>{{user.credits.credit - user.credits.debit}}</h4>
          </b-col>
        </b-row>
      </b-container>
      <h4 style="margin-top:30px">Transactions</h4>
      <loader v-if="loader"></loader>
  		<b-container v-else fluid class="solution-container" v-for="(transaction,index) in transactions" :key="transaction.id">
  			<b-link class="solution-link note">
  				<b-row>
  					<b-col lg="2" class="" style="display:flex;flex-direction: column;justify-content: center;">
  						<p class="date">{{get_human_date(transaction.created_at)}}</p>
  					</b-col>
  					<b-col lg="4">
  						<p>{{transaction.reference}}</p>
  						<!--<p class="doubt-description"><span class="qds-dot qds-active"></span> {{doubt.description.slice(0,50)}}...</p> -->
  					</b-col>
  					<b-col lg="5" class="sol-rating">
  						<!-- <p>Rate Solution:</p> -->
  						<!-- <div class="star-rating">
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: gold;" />
  							<font-awesome-icon icon="star" style="color: #fff;" />
  							<font-awesome-icon icon="star" style="color: #fff;" />
  						</div> -->
  					</b-col>
  					<b-col lg="1">

  						<span class="doubt-description sol-view" style="color:red" v-if="transaction.debit  > 0">-{{transaction.debit}}</span>
              <span class="doubt-description sol-view" v-else style="color:green">+{{transaction.credit}}</span>

  					</b-col>
  				</b-row>
  			</b-link>
  		</b-container>
  	</div>
  </div>
</template>

<script>
import dropdown from 'vue-my-dropdown';
import moment from 'moment';

export default {
  name: 'Transactions',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters:false,
      loader:true
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.user
    },
    transactions: function() {
    	return this.$store.getters.transactions;
    }
  },
  mounted: async function(){

    await this.$store.dispatch('fetch_transactions');
    this.loader = false;
  },
  methods: {
    get_human_date(d) {
      let mom = moment(d);
      return mom.format('LL');
    },
  },
  selected:null,
  search:''
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date {
  font-size: 0.8rem;
}
.solution-header {
	margin: 30px 0;
}
#solutions .custom-select,.sol-filter .form-control,.query-btn {
	border-radius: 20px;
	font-size: .8rem;
	line-height: 1.6rem;
}
.query-btn {
	width: 100%;
}
.sol-rating {
	display: inline-flex;
	justify-content: space-evenly;
	align-items: center;
}
.solution-link {
	background-color: #fff;
	margin: 10px 0px;
	display: block;
	color: black;
	padding: 20px;
}
.solution-link p {
	margin: 0;
}
.star-rating {
  line-height:32px;
  font-size:1.25em;
}
.sol-view {
	font-size: 3rem;
	line-height: 3rem;
	text-align: right;
}
.text-center {
	text-align: center;
}
.solution-link {
	border-left: 5px solid;
	border-color: #959090;
}
.qds-active-border {
	border-color:  #AACF37;
}

.doubt-description {
    /*display: none;*/
    font-size: 1rem;
}

@media screen and (min-width: 1280px) {
  .doubt-description {
    display: block;
  }
  .doubt-description.sol-view {
    font-size:1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Transactions.vue